import { BASE_URL } from "../api/api";

/**
 * Centralized webhook URL management for payment providers
 */
export class WebhookUrlService {
  /**
   * Get the webhook URL for a specific payment provider
   * This should match the backend webhook endpoint structure
   */
  public static getWebhookUrl(provider: string): string {
    switch (provider.toLowerCase()) {
      case 'wompi':
        return `${BASE_URL}/api/WompiPayment/webhook`;
      case 'n1co':
        return `${BASE_URL}/api/N1coPayment/webhook`;
      default:
        return `${BASE_URL}/api/${provider}Payment/webhook`;
    }
  }

  /**
   * Get success redirect URL for payment completion
   */
  public static getSuccessRedirectUrl(amortizationId: number, provider?: string): string {
    const baseUrl = window.location.origin;
    const params = new URLSearchParams({
      amortizationId: amortizationId.toString(),
      status: 'success'
    });
    
    if (provider) {
      params.set('provider', provider);
    }

    return `${baseUrl}/payment/success?${params.toString()}`;
  }

  /**
   * Get error redirect URL for payment failures
   */
  public static getErrorRedirectUrl(amortizationId: number, provider?: string, error?: string): string {
    const baseUrl = window.location.origin;
    const params = new URLSearchParams({
      amortizationId: amortizationId.toString(),
      status: 'error'
    });
    
    if (provider) {
      params.set('provider', provider);
    }
    
    if (error) {
      params.set('error', error);
    }

    return `${baseUrl}/payment/error?${params.toString()}`;
  }

  /**
   * Validate if a webhook URL is properly formatted for security
   */
  public static isValidWebhookUrl(url: string): boolean {
    try {
      const parsedUrl = new URL(url);
      
      // Must be HTTPS in production
      if (parsedUrl.protocol !== 'https:' && !url.includes('localhost')) {
        return false;
      }
      
      // Must contain webhook in the path
      if (!parsedUrl.pathname.includes('webhook')) {
        return false;
      }
      
      return true;
    } catch {
      return false;
    }
  }

  /**
   * Get all webhook URLs for debugging
   */
  public static getAllWebhookUrls(): Record<string, string> {
    return {
      wompi: this.getWebhookUrl('wompi'),
      n1co: this.getWebhookUrl('n1co'),
    };
  }
}
